import { ArrowRight, CheckCircle2, Hammer, MapPinned } from "lucide-react";
import { Reveal } from "./Reveal";

const cards = [
  {
    icon: CheckCircle2,
    tag: "Completed",
    title: "Delivered and earning",
    body: "Urban Veera has successfully completed multiple property projects with customers — built, handed over and structured for rental income.",
    tone: "bg-mist",
    testid: "project-completed",
  },
  {
    icon: Hammer,
    tag: "Ongoing",
    title: "One project under development",
    body: "A project is currently being developed with the same discipline — feasibility first, execution with established partners.",
    tone: "bg-butter",
    testid: "project-ongoing",
  },
  {
    icon: MapPinned,
    tag: "Upcoming · Bell Road",
    title: "Next project, starting soon",
    body: "Our next project is planned to start in Bell Road next month. We are also onboarding a limited number of new property opportunities — quality over quantity.",
    tone: "bg-peach",
    testid: "project-bell-road",
  },
];

export const Projects = () => (
  <section id="projects" className="bg-paper pb-20 md:pb-28" data-testid="projects-section">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="font-spec text-[11px] uppercase tracking-[0.25em] text-amberdark">Current & upcoming</p>
            <h2 className="mt-5 font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-tight text-navy sm:text-4xl" data-testid="projects-headline">
              Projects, <span className="text-amber">not promises.</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-steel">
            A small, deliberate pipeline. Every project is selected, underwritten
            and structured before it's offered.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3" data-testid="projects-grid">
        {cards.map((c, i) => (
          <Reveal key={c.tag} delay={i * 0.08}>
            <div data-testid={c.testid} className={`flex h-full flex-col rounded-3xl p-8 ${c.tone}`}>
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-amberdark shadow-soft">
                  <c.icon size={18} />
                </span>
                <span className="font-spec text-[10px] uppercase tracking-[0.2em] text-steel">{c.tag}</span>
              </div>
              <h3 className="mt-7 font-display text-xl font-extrabold tracking-tight text-navy">{c.title}</h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-steel">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-6 flex flex-col items-start justify-between gap-6 rounded-3xl bg-ink p-8 md:flex-row md:items-center md:p-10" data-testid="project-range-band">
          <div>
            <p className="font-spec text-[10px] uppercase tracking-[0.22em] text-white/50">Project range</p>
            <p className="mt-2 font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl">
              ₹4 Crore <span className="text-amber">→</span> ₹27 Crore+
            </p>
            <p className="mt-2 max-w-lg text-sm leading-relaxed text-white/60">
              Structures vary with location, land, construction, property type
              and customer requirements.
            </p>
          </div>
          <a
            href="#contact-form"
            data-testid="project-range-cta"
            className="group flex shrink-0 items-center gap-2.5 rounded-full bg-amber px-7 py-4 text-sm font-bold text-white transition-colors duration-300 hover:bg-amberdark"
          >
            Check your eligibility
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
